const pricingData = [
  {
    id: 1,
    title: "Basic Plan",
    price: "59",
    features: [
      "Basic Support",
      "1-Year Warranty",
      "Access to Standard Products",
    ],
  },
  {
    id: 2,
    title: "Standard Plan",
    price: "99",
    features: [
      "Priority Support",
      "2-Year Warranty",
      "Access to Premium Products",
    ],
    bestOffer: true,
  },
  {
    id: 3,
    title: "Premium Plan",
    price: "156",
    features: [
      "24/7 Support",
      "3-Year Warranty",
      "Access to Exclusive Products",
      "Free Shipping",
    ],
  },
];

export default pricingData;
